import { ExtensionType, extensions } from '@pixi/extensions';

class PluginSystem {
  constructor(renderer) {
    this.renderer = renderer;
    this.plugins = {};
  }
  init(staticMap) {
    for (const o in staticMap) {
      this.plugins[o] = new staticMap[o](this.renderer);
    }
  }
  destroy() {
    for (const o in this.plugins) {
      this.plugins[o].destroy();
      this.plugins[o] = null;
    }
  }
}
PluginSystem.extension = {
  type: [
    ExtensionType.RendererSystem,
    ExtensionType.CanvasRendererSystem
  ],
  name: "_plugin"
};
extensions.add(PluginSystem);

export { PluginSystem };
//# sourceMappingURL=PluginSystem.mjs.map
